import React, { useState } from 'react';
import { Popover } from 'is24-corecss';
import { callGovernanceApi } from '@/utils/ProtectedApiCall';
import { useSwitchContext } from '@/components/button/SwitchButtonContext';
import './SecretButton.css';

interface SecretButtonProps {
  id: string;
  loading?: boolean;
  secret?: string | null;
  error?: boolean;
  onStateChange: (id: string, state: SecretButtonState) => void;
}

export interface SecretButtonState {
  loading: boolean;
  error: boolean;
  secret: string | null;
}

const SecretButton: React.FC<SecretButtonProps> = ({ id, loading, secret, error, onStateChange }) => {
  const { selectedTenant } = useSwitchContext();
  const [popoverVisible, setPopoverVisible] = useState<boolean>(false);
  const buttonOnClick = () => {
    onStateChange(id, { loading: true, secret: null, error: false });
    callGovernanceApi(`/api/clients/${id}/secret?tenant=${selectedTenant}`, 'GET')
      .then((response) => {
        onStateChange(id, { loading: false, secret: response, error: false });
      })
      .catch(() => {
        onStateChange(id, { loading: false, secret: null, error: true });
      });
  };

  const handlePopoverClick = () => {
    setPopoverVisible(!popoverVisible);
  };

  return (
    <>
      {secret ? (
        <div className='parent'>
          <button className='button' data-testid={`secret-button-${id}`} onClick={handlePopoverClick}>
            Show secret
          </button>
          <Popover className='child' visible={popoverVisible}>
            {secret}
          </Popover>
        </div>
      ) : (
        <button
          data-testid={`secret-button-${id}`}
          onClick={buttonOnClick}
          disabled={loading || error}
          className='button'
        >
          {loading ? 'Loading...' : error ? 'No permission' : 'Fetch secret'}
        </button>
      )}
    </>
  );
};

export default SecretButton;
